import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipificacion',
  standalone: true
})
export class TipificacionPipe implements PipeTransform {

  tipificacion: any[] = [
    { "id": 0, "name": "Sin tipificaci\u00f3n" },
    { "id": 1, "name": "Solicitud informaci\u00f3n p\xfablica" },
    { "id": 2, "name": "Confidencial" },
  ]

  transform(id: number): string {
    if (id == null) return '';
    return this.tipificacion[id].name;
  }

}
